import { render, staticRenderFns } from "./RewardsIcon.vue?vue&type=template&id=62d3ec2e&"
import script from "./RewardsIcon.vue?vue&type=script&lang=ts&"
export * from "./RewardsIcon.vue?vue&type=script&lang=ts&"
import style0 from "./RewardsIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports